/**
 * Whether the Dash0 web SDK is configured in this environment.
 *
 * The web-events ingest token + endpoint ship as `NEXT_PUBLIC_*` values; when
 * either is absent (local dev / CI / the unauthenticated e2e preview) the SDK is
 * never initialised, so analytics calls must no-op. This guard is kept pure and
 * free of side effects — separate from the `instrumentation-client` entrypoint,
 * which runs SDK init on import — so any client module can import it safely.
 */
export function isDash0Enabled(): boolean {
  return (
    (process.env['NEXT_PUBLIC_DASH0_ENDPOINT_URL'] ?? '') !== '' &&
    (process.env['NEXT_PUBLIC_DASH0_WEB_TOKEN'] ?? '') !== ''
  );
}
